module.exports = "images/cervo.jpg";